export default __webpack_public_path__ + "static/media/swiper-paginate-inner-left.c8330670.png";